import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import Columns from "../Columns";

const ContentWrapper = styled.div`
    padding: 20px;
    margin: 3px;
    color: ${({ theme }) => theme.colors.blue.toString()};
    border: 2px solid ${({ theme }) => theme.colors.blue.toString()};
    border-radius: 10px;
`;

const columns = css`
    display: flex;
    justify-content: center;
`;

export const ToggleMore = styled.div`
    display: flex;
    justify-content: center;
    margin: 20px 0;
    font-size: 1rem;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`;

export const ProductDetails = styled.div`
    display: flex;
    flex-direction: column;
    font-family: var(--font-family-vito);
`;

export const ProductRow = styled.div`
    display: flex;
    padding-top: 2px;
    padding-bottom: 2px;
`;

export const ProductRowLabel = styled.div`
    display: flex;
    width: 50%;
    margin-right: 10px;
`;

export const ProductRowValue = styled.div`
    display: flex;
    flex-direction: column;
    font-weight: 500;
`;

export const ProductRowValueOnly = styled.div`
    display: block;
`;

export const ProductRowValueAddition = styled.span`
    white-space: nowrap;
`;

export const PriceLabel = styled.div`
    display: flex;
    width: 40%;
    margin-top: 10px;
`;

export const PriceValue = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 60%;
    margin-top: 10px;
`;

export const isTotal = css`
    font-size: 1.5rem;
    font-weight: 500;
`;

export const isOldPrice = css`
    text-decoration: line-through;
`;

export const isReduction = ({ theme }) => css`
    color: ${theme.colors.red.toString()};
`;

export const adjustPriceActionMargin = css`
    margin-bottom: 100px;
`;

export const adjustButtonMargin = css`
    margin-top: 10px;
    margin-bottom: 10px;
`;

export const ExpandedContent = styled.div`
    margin-top: 0;
`;

const CalculatorProductDetails = ({ children, activeIndex }) => {
    const theme = useTheme();

    const activeContent = css`
        margin: 2px;
        border: 3px solid ${theme.colors.red.toString()};
    `;

    const inactiveColumn = css`
        ${theme.breakpoints.upTo.small.css`
            display: none !important;
        `}
    `;

    return (
        <Columns
            sameHeight
            css={columns}
            className={`is-mobile is-variable is-1-mobile`}
        >
            {React.Children.map(children, (child, index) => {
                const isActiveElement = index === parseInt(activeIndex);
                return (
                    <Columns.Column
                        mobile="full"
                        desktop={"one-third"}
                        key={`product-${index}`}
                        css={!isActiveElement ? inactiveColumn : ""}
                    >
                        <ContentWrapper
                            css={css`
                                ${isActiveElement ? activeContent : ""}
                            `}
                        >
                            {child}
                        </ContentWrapper>
                    </Columns.Column>
                );
            })}
        </Columns>
    );
};

export default CalculatorProductDetails;
